var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('section-title',[_vm._v("注意事项")]),_c('notice',{attrs:{"content":_vm._f("decodeHTML")(_vm.notice)}}),_c(_vm.type,{tag:"div"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }